import { useNavigation, useOptionsetMetadata, useTranslation } from '@msdk/common'
import { BaseOptionDefinition, Entity } from '@msdk/definitions'
import { useComponentModal } from '@msdk/forms'
import { IconSelector, Tooltip } from '@msdk/ui'
import { EmptyIcon } from 'components/Sidebar/EmptyIcon'
import { SidebarListItemButton } from 'components/Sidebar/SidebarItemButton'
import { SidebarListItemText } from 'components/Sidebar/SidebarItemText'
import { SidebarList } from 'components/Sidebar/SidebarList'
import { SidebarListItem } from 'components/Sidebar/SidebarListItem'
import { SidebarListItemIcon } from 'components/Sidebar/SidebarListItemIcon'
import { SidebarDivider } from 'components/SidebarDivider'
import { useDocuments } from 'state/documents'
import { useNavigationMenu } from 'state/navigation-menu'

import { DocumentViewer } from './DocumentViewer'

export function DocumentSection() {
  const t = useTranslation()
  const documents = useDocuments()
  const docOpt = useOptionsetMetadata('CMPS', 'DOCUMENT_TYPES')
  const { navigationMenuOpen, setNavigationMenu } = useNavigationMenu()
  const { createModal } = useComponentModal()
  const navigate = useNavigation()

  const translateOpt = (value: string) => {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const opt = docOpt?.options.find((opt) => opt.value === value) as BaseOptionDefinition
    return t(opt?.idml, opt?.description)
  }

  const handleClick = (doc: Entity) => {
    const modalRef = createModal(
      <DocumentViewer entity={doc} />,
      () => {
        //
      },
      {
        preventClickOutside: false,
        preventEscapeFromClosing: false,
      },
    )
    modalRef.open()
  }

  const handleAboutClick = () => {
    setNavigationMenu(true)
    navigate('About')
  }

  const content = navigationMenuOpen ? (
    <>
      {documents.length > 0
        ? documents.map((d) => (
            <SidebarListItem key={d.id} level={1} onClick={() => handleClick(d)}>
              <EmptyIcon data-test-id="empty-icon" />
              <SidebarListItemText>{translateOpt(d.fields['TYPE']?.value)}</SidebarListItemText>
            </SidebarListItem>
          ))
        : null}
      <SidebarListItem
        level={1}
        onClick={() => {
          handleAboutClick()
        }}
      >
        <EmptyIcon />
        <SidebarListItemText>{t('ABOUT', 'About')}</SidebarListItemText>
      </SidebarListItem>
    </>
  ) : (
    <Tooltip title={t('LBL_SIDEMENU_MORE', 'More')} placement="right">
      <SidebarListItemButton
        onClick={() => {
          setNavigationMenu(false)
        }}
        level={0}
      >
        <SidebarListItemIcon>
          <IconSelector iconName="MoreHoriz" />
        </SidebarListItemIcon>
      </SidebarListItemButton>
    </Tooltip>
  )

  return (
    <>
      <SidebarDivider className="horizontal-margin" />
      <SidebarList component="nav">{content}</SidebarList>
    </>
  )
}
